import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Amplify } from 'aws-amplify'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Button, Grid, Modal, TextField } from '../../../../components/mui/Core/index'
import awsconfig from '../../../../aws-exports'
import LinkButton from '../../../../components/LinkButton/link-button'
import Constants from '../../../../constants/en.json'
import SubHeader from '../../../../components/SubHeader/sub-header'
import PasswordValidation from '../../../../components/PasswordValidation/password-validation'

Amplify.configure(awsconfig)

function ChangePasswordModal({ handleSubmitUpdatedPassword }) {
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordAgain, setNewPasswordAgain] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    setCurrentPassword('')
    setNewPassword('')
    setNewPasswordAgain('')
  }
  const isForm2Valid =
    !newPassword ||
    !currentPassword ||
    !newPasswordAgain ||
    !isPasswordValid ||
    newPassword !== newPasswordAgain

  const handlePasswordValidation = (isValid) => {
    setIsPasswordValid(isValid)
  }

  const handleSubmit = async () => {
    if (handleSubmitUpdatedPassword) {
      handleSubmitUpdatedPassword(newPassword, newPasswordAgain, currentPassword, handleClose)
    }
  }

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '550px',
    transform: 'translate(-50%, -50%)',
    bgcolor: theme.palette.common.white,
    boxShadow: 24,
    p: 4,
    borderRadius: '12px',
  }

  const textFieldStyle = {
    mb: 2,
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.secondary.main,
      },
    },
  }

  const modalActionsStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
  }

  return (
    <div>
      <LinkButton
        fontSize='16px'
        handleLinkClick={() => {
          handleOpen()
        }}
        linkText={Constants.accountSettings.changePassword.CHANGE_BUTTON_TEXT}
      />
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12 }}>
              <SubHeader title={Constants.accountSettings.changePassword.CHANGE_PASSWORD} />
            </Grid>
            <Grid size={{ xs: 5 }}>
              <TextField
                required
                onChange={(e) => setCurrentPassword(e.target.value)}
                label={Constants.accountSettings.changePassword.CURRENT_PASSWORD}
                type='password'
                value={currentPassword}
                sx={textFieldStyle}
              />
              <TextField
                required
                onChange={(e) => setNewPassword(e.target.value)}
                label={Constants.accountSettings.changePassword.NEW_PASSWORD}
                type='password'
                value={newPassword}
                sx={textFieldStyle}
              />
              <TextField
                required
                onChange={(e) => setNewPasswordAgain(e.target.value)}
                label={Constants.accountSettings.changePassword.CONFIRM_PASSWORD}
                type='password'
                value={newPasswordAgain}
                sx={textFieldStyle}
              />
            </Grid>
            <Grid size={{ xs: 7 }}>
              <PasswordValidation
                value={newPassword}
                handlePasswordValidation={handlePasswordValidation}
              />
            </Grid>
            <Grid size={{ xs: 12 }} sx={modalActionsStyle}>
              <Button
                onClick={handleClose}
                variant='outlined'
                color='secondary'
                sx={{ mt: 2, mr: 4 }}
              >
                {Constants.accountSettings.changePassword.CANCEL_BUTTON_TEXT}
              </Button>
              <Button
                onClick={handleSubmit}
                variant='contained'
                color='secondary'
                sx={{ mt: 2, mr: 1 }}
                disabled={isForm2Valid}
              >
                {Constants.accountSettings.changePassword.SAVE_BUTTON_TEXT}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  )
}

ChangePasswordModal.propTypes = {
  handleSubmitUpdatedPassword: PropTypes.func.isRequired,
}

export default ChangePasswordModal
